// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProfileSkillsList_elements__QfWeG {
  width: 100%;
  padding: 0 20px;
}
.ProfileSkillsList_elements__QfWeG a {
  color: inherit;
  text-decoration: none;
  font-weight: normal;
}
.ProfileSkillsList_elements__QfWeG ul {
  list-style: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 10px 0;
}
.ProfileSkillsList_elements__QfWeG ul li,
.ProfileSkillsList_elements__QfWeG ul input {
  background-color: rgb(218, 218, 218);
  padding: 10px 20px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  border-radius: 20px;
}
.ProfileSkillsList_elements__QfWeG ul li {
  margin: 5px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.ProfileSkillsList_elements__QfWeG ul input {
  border: 2px solid rgb(138, 175, 221);
  background-color: rgb(240, 240, 240);
}
.ProfileSkillsList_elements__QfWeG ul span {
  display: flex;
  flex-direction: row;
}
.ProfileSkillsList_elements__QfWeG ul button {
  margin-right: 15px;
  background-color: transparent;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
}
.ProfileSkillsList_elements__QfWeG ul button:hover {
  background-color: rgba(0, 0, 0, 0.0666666667);
}
.ProfileSkillsList_elements__QfWeG ul button:active {
  background-color: rgba(0, 0, 0, 0.1333333333);
}
.ProfileSkillsList_elements__QfWeG ul button svg {
  fill: grey;
}`, "",{"version":3,"sources":["webpack://./src/Components/ProfileSkillsList/ProfileSkillsList.module.scss"],"names":[],"mappings":"AAAA;EACG,WAAA;EACA,eAAA;AACH;AACG;EACG,cAAA;EACA,qBAAA;EACA,mBAAA;AACN;AAEG;EACG,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;AAAN;AAEM;;EAEG,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,mBAAA;AAAT;AAGM;EACG,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AADT;AAKM;EACG,oCAAA;EACA,oCAAA;AAHT;AAMM;EACG,aAAA;EACA,mBAAA;AAJT;AAOM;EACG,kBAAA;EACA,6BAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AALT;AAOS;EACG,6CAAA;AALZ;AAQS;EACG,6CAAA;AANZ;AASS;EACG,UAAA;AAPZ","sourcesContent":[".elements {\n   width: 100%;\n   padding: 0 20px;\n\n   a {\n      color: inherit;\n      text-decoration: none;\n      font-weight: normal;\n   }\n\n   ul {\n      list-style: none;\n      display: flex;\n      flex-direction: row;\n      flex-wrap: wrap;\n      padding: 10px 0;\n\n      li,\n      input {\n         background-color: rgb(218, 218, 218);\n         padding: 10px 20px;\n         height: 40px;\n         display: flex;\n         align-items: center;\n         justify-content: flex-start;\n         flex-direction: row;\n         border-radius: 20px;\n      }\n\n      li {\n         margin: 5px;\n         text-overflow: ellipsis;\n         white-space: nowrap;\n         overflow: hidden;\n\n      }\n\n      input {\n         border: 2px solid rgb(138, 175, 221);\n         background-color: rgb(240, 240, 240);\n      }\n\n      span {\n         display: flex;\n         flex-direction: row;\n      }\n\n      button {\n         margin-right: 15px;\n         background-color: transparent;\n         border: none;\n         display: inline-flex;\n         align-items: center;\n         justify-content: center;\n         padding: 5px;\n\n         &:hover {\n            background-color: #0001;\n         }\n\n         &:active {\n            background-color: #0002;\n         }\n\n         svg {\n            fill: grey;\n         }\n      }\n   }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"elements": `ProfileSkillsList_elements__QfWeG`
};
export default ___CSS_LOADER_EXPORT___;
